(() => {
  let alignmentFrame;
  const alignButtons = () => {
    const buttons = [...document.querySelectorAll('.product-block .sn-card-buy')];
    buttons.forEach(button => button.style.setProperty('--sn-buy-offset', '0px'));
    const sections = new Map();
    buttons.forEach(button => {
      const card = button.closest('.product-block');
      if (!card.getClientRects().length) return;
      const section = card.closest('.shopify-section') || card.parentElement;
      if (!sections.has(section)) sections.set(section, []);
      const rows = sections.get(section);
      const top = card.getBoundingClientRect().top;
      let row = rows.find(row => Math.abs(row.top - top) < 3);
      if (!row) { row = {top, items: []}; rows.push(row); }
      row.items.push({button, top: button.getBoundingClientRect().top});
    });
    sections.forEach(rows => rows.forEach(row => {
      const bottom = Math.max(...row.items.map(item => item.top));
      row.items.forEach(item => item.button.style.setProperty('--sn-buy-offset', Math.max(0, bottom - item.top) + 'px'));
    }));
    document.querySelectorAll('.collection-slider.flickity-enabled').forEach(slider => {
      const carousel = window.themeVendor?.Flickity?.data(slider);
      if (carousel) carousel.resize();
    });
  };
  const scheduleAlignment = () => {
    cancelAnimationFrame(alignmentFrame);
    alignmentFrame = requestAnimationFrame(alignButtons);
  };
  const observedCards = new WeakSet();
  const cardObserver = new ResizeObserver(scheduleAlignment);
  document.addEventListener('theme:resize', scheduleAlignment);
  window.addEventListener('resize', scheduleAlignment, {passive: true});
  document.addEventListener('load', scheduleAlignment, true);
  document.fonts.ready.then(scheduleAlignment);
  const placeButtons = () => {
    document.querySelectorAll('.product-block .sn-card-buy').forEach(button => {
      const card = button.closest('.product-block');
      if (!observedCards.has(card)) {
        observedCards.add(card);
        cardObserver.observe(card);
      }
    });
    scheduleAlignment();
  };
  let pendingCartOpen = false;
  document.addEventListener('theme:product:add', event => {
    if (event.detail?.button?.closest('product-form')) pendingCartOpen = true;
  });
  document.addEventListener('theme:product:added', () => {
    if (!pendingCartOpen) return;
    pendingCartOpen = false;
    const drawer = document.querySelector('cart-drawer');
    if (drawer && !drawer.classList.contains('is-open')) drawer.dispatchEvent(new CustomEvent('theme:cart-drawer:show'));
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-sn-variant]')) return;
    const select = event.target;
    const option = select.selectedOptions[0];
    const form = select.form;
    form.querySelector('[name="quantity"]').value = option.dataset.min || '1';
    form.querySelector('[type="submit"]').disabled = !select.value || option.disabled;
    scheduleAlignment();
  });
  placeButtons();
  const observer = new MutationObserver(placeButtons);
  observer.observe(document.querySelector('main') || document.body, {childList: true, subtree: true});
})();
